import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsState } from './forms.state';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forFeature([FormsState])
  ]
})
export class FormsStoreModule { }
